export default "__VITE_ASSET__BaPDpCcf__"